export const LocalVariableNameOption = {
    type: 'textinput',
    label: 'Local variable',
    id: 'name',
    default: '',
};
//# sourceMappingURL=LocalVariable.js.map